export default async function CopySessionLink(username: string) {
  const url = `insessions.co/${username}`;
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(url);
  }
}
